/**
 * Card Component - Theme-aware card container
 * Pattern based on mcp-admin KpiCard and github-admin KPICard
 */

const React = (globalThis as any).React;
const { useState } = React;

import { styles } from '../styles';

export interface CardProps {
  children: React.ReactNode;
  hoverable?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
  className?: string;
  title?: string;
  extra?: React.ReactNode;
}

export function Card({
  children,
  hoverable = false,
  onClick,
  style,
  className,
  title,
  extra,
}: CardProps) {
  const [isHovered, setIsHovered] = useState(false);
  
  const cardStyle: React.CSSProperties = {
    ...styles.card,
    ...(isHovered && hoverable ? styles.cardHover : {}),
    ...(onClick ? { cursor: 'pointer' } : {}),
    ...style,
  };
  
  // WCAG: Semantic HTML (article for card content)
  const Component = onClick ? 'article' : 'div';
  
  return React.createElement(Component, {
    style: cardStyle,
    className,
    onMouseEnter: hoverable ? () => setIsHovered(true) : undefined,
    onMouseLeave: hoverable ? () => setIsHovered(false) : undefined,
    onClick,
    role: onClick ? 'button' : undefined,
    tabIndex: onClick ? 0 : undefined,
    onKeyDown: onClick ? (e: any) => {
      // WCAG: Keyboard navigation (Enter/Space)
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick();
      }
    } : undefined,
    'aria-label': onClick && !title ? 'Clickable card' : undefined,
  },
    title && React.createElement('div', {
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '16px',
        paddingBottom: '16px',
        borderBottom: '1px solid var(--border-color)',
      },
    },
      React.createElement('h3', {
        style: {
          margin: 0,
          fontSize: '18px',
          fontWeight: '600',
          color: 'var(--main-text)',
        },
      }, title),
      extra
    ),
    children
  );
}

